module.exports = __webpack_public_path__ + "static/media/ONLINEP99.1723a016.png";